<ng-template #iconTemplate>
  <div class="flex-row">
    <div class="flex-row gap-8 ml-auto">
      @if (!readOnly()) {
        <vl-chips state="warn" iconLeft="delete" (action)="onDelete()"/>
      }
      <vl-chips iconLeft="fullscreen" (action)="openFile()"/>
    </div>
  </div>
</ng-template>

<!-- Rendu proportionnel : remplace width/height par max-width/max-height + object-fit -->
<ng-template #imageConstrainedTemplate>
  <img
    [src]="file().url"
    alt=""
    [style.border-radius]="borderradius() ? '8px' : '0px'"
    [style.opacity]="opacity()"
    [style.max-height]="maxHeight() || null"
    [style.max-width]="maxWidth() || '100%'"
    style="width: 100%; height: auto; object-fit: contain; display: block;"
    (click)="onImageClick($event)"/>
</ng-template>

<div class="flex-row justify-center w100" [ngClass]="opacitygradient() ? 'opacity-gradient' : ''">
  @if ((!metaData() || metaData()?.loading) && !file()?.url) {
    <div class="flex-row mt-16">
      <ngx-skeleton-loader count="1"
                           [theme]="{'height': height(), 'width': width(), 'background-color': 'var(--color-on-disabled)'}"/>
    </div>
  } @else {
    <div [style.width]="(maxHeight() || maxWidth()) ? '100%' : width()">
      @switch (contentType()) {
        @case ('application/pdf') {
          <div [style.max-width]="width()" class="flex-col gap-8 w100">
            <ng-container *ngTemplateOutlet="iconTemplate"/>
            @if (showPdf()) {
              <div [style.max-height]="height()">
                <object [data]="sanitizedUrl()" type="application/pdf"></object>
              </div>
            } @else {
              <img (click)="openFile()" src="assets/icons/pdf.png" alt="loader" class="w-56 h-auto cursor-pointer"/>
            }
          </div>
        }
        @case ('image/jpeg') {
          <div class="flex-col gap-8">
            @if (showActions() && !readOnly()) {
              <div class="flex-row"><vl-chips class="ml-auto" state="warn" iconLeft="delete" (action)="onDelete()"/></div>
            }
            @if (maxHeight() || maxWidth()) {
              <ng-container *ngTemplateOutlet="imageConstrainedTemplate"/>
            } @else {
              <div
                class="image-mask"
                [style.border-radius]="borderradius() ? '8px' : '0px'"
                [style.opacity]="opacity()"
                [style.width]="width()"
                [style.height]="height()"
                [style.backgroundImage]="'url('+file().url+')'"
                (click)="onImageClick($event)">
              </div>
            }
          </div>
        }
        @case ('image/gif') {
          <div class="flex-col gap-8">
            @if (showActions() && !readOnly()) {
              <div class="flex-row"><vl-chips class="ml-auto" state="warn" iconLeft="delete" (action)="onDelete()"/></div>
            }
            @if (maxHeight() || maxWidth()) {
              <ng-container *ngTemplateOutlet="imageConstrainedTemplate"/>
            } @else {
              <img
                class="image-mask"
                [src]="file().url"
                [style.border-radius]="borderradius() ? '8px' : '0px'"
                [style.opacity]="opacity()"
                [style.width]="width()"
                [style.height]="height()"
                (click)="onImageClick($event)"/>
            }
          </div>
        }
        @case ('image/webp') {
          <div class="flex-col gap-8">
            @if (showActions() && !readOnly()) {
              <div class="flex-row"><vl-chips class="ml-auto" state="warn" iconLeft="delete" (action)="onDelete()"/></div>
            }
            @if (maxHeight() || maxWidth()) {
              <ng-container *ngTemplateOutlet="imageConstrainedTemplate"/>
            } @else {
              <div
                class="image-mask"
                [style.border-radius]="borderradius() ? '8px' : '0px'"
                [style.opacity]="opacity()"
                [style.width]="width()"
                [style.height]="height()"
                [style.backgroundImage]="'url('+file().url+')'"
                (click)="onImageClick($event)">
              </div>
            }
          </div>
        }
        @case ('image/png') {
          <div class="flex-col gap-8">
            @if (showActions() && !readOnly()) {
              <div class="flex-row"><vl-chips class="ml-auto" state="warn" iconLeft="delete" (action)="onDelete()"/></div>
            }
            @if (maxHeight() || maxWidth()) {
              <ng-container *ngTemplateOutlet="imageConstrainedTemplate"/>
            } @else {
              <div
                class="image-mask"
                [style.border-radius]="borderradius() ? '8px' : '0px'"
                [style.opacity]="opacity()"
                [style.width]="width()"
                [style.height]="height()"
                [style.backgroundImage]="'url('+file().url+')'"
                (click)="onImageClick($event)">
              </div>
            }
          </div>
        }
        @case ('audio/mpeg') {
          <div [style.max-width]="width()" class="flex-col gap-8 w100">
            <ng-container *ngTemplateOutlet="iconTemplate"/>
            <audio style="width: 100%" controls>
              <source [src]="sanitizedUrl()" type="audio/mpeg"/>
              Votre navigateur ne supporte pas la lecture audio.
            </audio>
          </div>
        }
        @case ('video/mp4') {
          <div [style.max-width]="width()" class="flex-col gap-8 w100">
            <ng-container *ngTemplateOutlet="iconTemplate"/>
            <video style="width: 100%" controls>
              <source [src]="sanitizedUrl()" type="video/mp4"/>
              Votre navigateur ne supporte pas la lecture vidéo.
            </video>
          </div>
        }
        @case ('video/webm') {
          <div [style.max-width]="width()" class="flex-col gap-8 w100">
            <ng-container *ngTemplateOutlet="iconTemplate"/>
            <video style="width: 100%" controls>
              <source [src]="sanitizedUrl()" type="video/webm"/>
              Votre navigateur ne supporte pas la lecture vidéo.
            </video>
          </div>
        }
        @default {
          <ng-container *ngTemplateOutlet="iconTemplate"/>
          <a [href]="sanitizedUrl()" download>Télécharger le fichier</a>
        }
      }
    </div>
  }
</div>
